import { useDispatch, useSelector, createSelectorHook } from "react-redux";
import { createStore, applyMiddleware, compose, AnyAction } from "redux";
import thunkMiddleware, { ThunkDispatch } from "redux-thunk";
import rootReducer from "../reducers/index";
import { env } from "../../env";

let composeEnhancers = compose;
if (
  env.NODE_ENV !== "production" &&
  //@ts-ignore
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
) {
  //@ts-ignore
  composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
}

export function buildStore(preloadedState = {}) {
  return createStore(
    rootReducer,
    preloadedState,
    composeEnhancers(applyMiddleware(thunkMiddleware)),
  );
}

export default buildStore();

export type AppState = ReturnType<typeof rootReducer>;

export const useAppSelector: createSelectorHook<AppState> = useSelector;

type AppDispatch = ThunkDispatch<AppState, any, AnyAction>;

export const useAppDispatch: () => AppDispatch = useDispatch;
